class Environment {
    constructor($rootElement) {
        this.$rootElement = $rootElement;
    }

    getCurrentEnvironment() {
        return this.$rootElement.attr('data-environment');
    }
}

Environment.$inject = ['$rootElement'];

export default Environment;